import React, { useEffect } from 'react';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import './trabalhe_conosco.css';
import { assets } from "../assets/assets";

const TrabalheNos = () => {

  const abrirWhatsTrabalheConosco = () => {
    const numero = '5571999556884';
    const mensagem = `Olá! Vi a seção "Junte-se a nós" no site e gostaria de saber mais sobre as oportunidades na Trinco.`;
    window.open(`https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`, '_blank');
  };

  useEffect(() => {
    document.title = "Trinco | Trabalhe conosco";
  }, []);

  return (
    <>
      <Header />
      <div className="trabalhe-pagina-container">

        <header className="trabalhe-header-topo">
          <h1 className="titulo-principal">JUNTE-SE A NÓS</h1>
          <p>Construa sua história com a Trinco.</p>
        </header>

        <section className="trabalhe-cards-grid">

          {/* Card 1: Treinamento */}
          <div className="trabalhe-card">
            <div className="card-img-wrapper">
              <img src={assets.balcaoTrinco} alt="Treinamento" />
            </div>
            <div className="card-info">
              <h3>Aprendizado no balcão</h3>
              <p>Oferecemos um programa abrangente desde o primeiro dia. Em cerca de 16 semanas você domina o básico, mas o aprendizado aqui é contínuo e compartilhado.</p>
            </div>
          </div>

          {/* Card 2: Carreira */}
          <div className="trabalhe-card">
            <div className="card-img-wrapper">
              <img src={assets.carreiraTrinco} alt="Carreira" />
            </div>
            <div className="card-info">
              <h3>Progressão de Carreira</h3>
              <p>Preferimos promover internamente. Nossos gerentes começaram nas lojas, e você receberá todo o incentivo para seguir o mesmo caminho.</p>
            </div>
          </div>

          {/* Card 3: Inclusão */}
          <div className="trabalhe-card">
            <div className="card-img-wrapper">
              <img src={assets.oportunidadesTrinco} alt="Inclusão" />
            </div>
            <div className="card-info">
              <h3>Oportunidades reais</h3>
              <p>Mais que currículos, buscamos personalidades. Oferecemos chances reais para pessoas de todas as origens e grupos que buscam um novo começo.</p>
            </div>
          </div>

        </section>

        {/* BOTÃO VER OPORTUNIDADES */}
        <div className="trabalhe-acoes-container">
          <button className="btn-ver-vagas" onClick={abrirWhatsTrabalheConosco}>
            Ver Oportunidades
          </button>

          <p className="texto-apoio-btn">
            Clique acima para falar com nosso RH e conhecer as vagas disponíveis.
          </p>
        </div>

      </div>
      <Footer />
    </>
  );
}

export default TrabalheNos;